import { ReactNode, useRef } from 'react';
import { useSetAtom } from 'jotai';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'react-i18next';
import { Button, Input } from '@forma/forma-ui-kit';

import { addNotificationAtom } from '@/store/notifications';

import styles from './copy-input.module.css';

const copyToClipboard = (input: HTMLInputElement) => {
  let result;

  input.focus();
  input.select();

  try {
    const successful = document.execCommand('copy');
    result = successful ? 'success' : 'error';
  } catch (err) {
    result = 'error';
  }

  input.setSelectionRange(0, 0);

  return result;
};

interface CopyInputProps {
  label?: ReactNode,
  value: string
}

const CopyInput = ({ label, value }: CopyInputProps) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  const addNotification = useSetAtom(addNotificationAtom);

  const handleCopyLink = () => {
    if (!inputRef.current) return;
    const res = copyToClipboard(inputRef.current);
    inputRef.current.blur();
    if (res === 'success') addNotification({ id: 'code_copy', content: t('copied'), type: 'SUCCESS' });
    // webView.sendMessage(`openShare ${value}`);
  };

  const handleInputClick = () => {
    inputRef.current?.select();
  };

  return (
    <div className={styles.root}>
      <Input
        className={styles.input}
        value={value}
        // readOnly
        meta={{
          label,
          labelClass: styles.label,
          containerClass: styles.container
        }}
        ref={inputRef}
        onClick={handleInputClick}
      />
      <Button
        viewStyle="text"
        icon={<ReactSVG src="/icons/copy.svg" wrapper="span" />}
        className={styles.copyButton}
        onClick={handleCopyLink}
      />
    </div>
  );
};

export default CopyInput;
